module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av276-26e70f33900e0ebbcaf03e4eff594513.jpg";